import React, {
  Fragment,
  useEffect,
  useRef,
  useState,
  useCallback,
} from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import BadgeIcon from "../../../Icons/BadgeIcon";
import ShowRewards from "../../../Components/FeComponents/Popups/ShowRewards";
import InstructionIcon from "../../../Icons/InstructionIcon";
import ExternalRewardIcon from "../../../Icons/ExternalRewardIcon";
import HostedRewardIcon from "../../../Icons/HostedRewardIcon";
import AudioRewardIcon from "../../../Icons/AudioRewardIcon";
import VideoRewardIcon from "../../../Icons/VideoRewardIcon";
import axios from "axios";
import config from "../../../config";
import { useLoader } from "../../../hooks/LoaderContext";
function PrizeSetup({
  isOpen = false,
  onClose,
  title,
  contest_id,
  enddateError,
  contest_member_id,
  lang,
}) {
  const cancelButtonRef = useRef(null);
  const [prizesetup, setprizesetup] = useState({});
  const [ribbontext, setribbontext] = useState(null);
  const [displayreward, setdisplayreward] = useState(0);
  const [activerewards, setactiverewards] = useState({});
  const [winnerlist, setwinnerlist] = useState({});
  const { showLoader, hideLoader } = useLoader();
  const hasFetchedData = useRef(false);

  const gotoRewardsPage = (val, prize) => {
    setdisplayreward(val);
    setactiverewards(prize);
  };
  const handleDownload = (prize) => {
    if (prize.reward_file) {
      let fileName = prize.reward_file;
      const fileExtension = prize.reward_file.split(".").pop().split(/#|\?/)[0];

      // Ensure the fileName has the correct extension
      if (!fileName.endsWith(`.${fileExtension}`)) {
        fileName = fileName + `.${fileExtension}`;
      }

      // Create a download link
      const link = document.createElement("a");
      link.href = prize.reward_file; // Use the reward_file URL here
      link.download = fileName; // Set the download filename
      link.click();
    }
  };

  const gotoExternalUl = (prize) => {
    if (prize.reward_file) {
      window.open(prize.reward_file, "_blank");
    }
  };

  const fewinnerlist = useCallback(async () => {
    //showLoader();
    let payload = {
      contest_id: contest_id,
    };

    try {
      const res = await axios.post(
        `${config.API_URL}/fe-get-winner-list`,
        payload
      );
      if (res.status === 200) {
        console.log(res.data.winnerlist);
        setwinnerlist(res.data.winnerlist);
      }
    } catch (error) {
      console.error(error);
    } finally {
     // hideLoader();
    }
  }, [contest_id]);

  // useEffect(() => {
  //   if (prizesetup.length > 0) {
  //     fewinnerlist();
  //   }
  // }, [prizesetup, fewinnerlist]);

  const fePrizeSetupdetail = useCallback(async () => {
    showLoader();
    setdisplayreward(0);
    const session_member = sessionStorage.getItem("member_" + contest_id);
    if (session_member) {
      const memberDet = JSON.parse(session_member);
      try {
        let payload = {
          contest_id: contest_id,
          contest_member_id: memberDet.contest_member_id,
          type: "prize",
        };

        const res = await axios.post(
          `${config.API_URL}/get-prize-setup`,
          payload
        );
        if (res.status === 200) {
          console.log(res.data.prize);
          setprizesetup(res.data.prize);
          if (res.data.ribbon_text) {
            setribbontext(res.data.ribbon_text);
          }
           fewinnerlist();
        
        }
      } catch (error) {
        console.log(error);
      } finally {
         
        hideLoader();
      }
    }
  }, [contest_id,showLoader,hideLoader,fewinnerlist]);
  useEffect(() => {
  if (isOpen && !hasFetchedData.current) {
    fePrizeSetupdetail();
    hasFetchedData.current = true;
  }

  // Reset flag on close
  if (!isOpen) {
    hasFetchedData.current = false;
  }
 }, [isOpen, fePrizeSetupdetail]);

  function trimdescription(description) {
    const maxLength = 210;
    const trimmedDescription =
      description.length > maxLength
        ? description.substring(0, maxLength) + "..."
        : description;
    return trimmedDescription;
  }

  return (
    <Transition.Root show={isOpen} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={onClose}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all w-full max-w-3xl">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="flex items-center justify-between border-b pb-3">
                    <Dialog.Title
                      as="h3"
                      className="text-lg font-bold text-gray-900 flex items-center gap-3"
                    >
                      <img
                        src="https://img.flexifunnels.com/flexicontest/prize_ribbon.svg"
                        alt=""
                      />
                      <div>
                        <h2>{title}</h2>

                        {ribbontext && (
                          <p className="text-sm font-normal text-gray-500">
                            {ribbontext}
                          </p>
                        )}
                      </div>
                    </Dialog.Title>
                    <button
                      type="button"
                      className="absolute right-3 top-3 rounded-md bg-[#E5E5E5A3]  p-1 text-gray-500"
                      onClick={onClose}
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon
                        className="h-5 w-5 text-black"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                  {/* Scrollable Content */}
                  <div className="p-4 flex flex-col items-center gap-4 overflow-y-auto max-h-[70vh] scrollbar-custom">
                    {Array.isArray(prizesetup) &&
                    prizesetup.length > 0 &&
                    displayreward === 0 ? (
                      prizesetup.map((prize, index) => (
                        <div
                          key={index}
                          className="primary_border_color relative flex flex-col sm:flex-row items-center border rounded-lg shadow-lg w-full bg-white h-auto border-[#5CA8FF]"
                        >
                          {/* <div className="relative w-full sm:w-[180px]">
                                                    <img
                                                        src={prize?.reward_image}
                                                        alt={prize?.reward_name}
                                                        className="w-[180px] h-[156px] object-cover rounded-s-md"
                                                    />
                                                </div> */}
                          <div className="relative w-full sm:w-[180px] p-2">
                            {prize.reward_image ? (
                              <div className="flex justify-center bg-white rounded-t-md md:rounded-none lg:rounded-s-md">
                                <img
                                  src={prize.reward_image}
                                  // src='/prize.png'
                                  alt={prize.reward_name}
                                  className="object-cover rounded-md sm:w-[180px] h-[156px]"
                                />
                              </div>
                            ) : (
                              <div className="w-full sm:w-[180px] h-[156px]  flex justify-center items-center rounded-s-md">
                                {/*  */}
                                <img
                                  src={
                                    prize.reward_type === 1
                                      ? "https://img.flexifunnels.com/flexicontest/instruction.svg"
                                      : prize.reward_type === 2
                                      ? "https://img.flexifunnels.com/flexicontest/external.svg"
                                      : prize.reward_type === 3
                                      ? "https://img.flexifunnels.com/flexicontest/video.svg"
                                      : prize.reward_type === 4
                                      ? "https://img.flexifunnels.com/flexicontest/audio.svg"
                                      : prize.reward_type === 5
                                      ? "https://img.flexifunnels.com/flexicontest/hosted.svg"
                                      : ""
                                  }
                                  alt={prize.reward_name}
                                  className="object-cover rounded-md sm:w-[180px] h-[156px]"
                                />
                              </div>
                            )}
                          </div>
                          <div className="group p-4 flex flex-col flex-1 w-full sm:w-[180px]">
                            <h2 className="text-[14px] leading-[17px] font-semibold text-black opacity-90 text-left mb-1">
                              {prize?.reward_name}
                            </h2>
                            <p className="text-[12px] leading-[17px] py-1 text-left text-[#767676] opacity-100 mb-1">
                              {trimdescription(prize?.reward_description)}
                            </p>
                            <div className="md:flex md:flex-row flex flex-col bg-[#00000008] md:items-center gap-4 p-3 rounded-md text-gray-700 text-sm">
                              {/* <div className="flex w-full h-[43px] p-[5px] rounded-md"> */}
                              <div className="flex pb-2 md:pb-0 border-b md:border-b-0">
                                <div className="primary_light_bgcolor2 bg-[#C3DEFD] text-[#0274F7] rounded-[3px] opacity-70 flex items-center justify-center p-2 mr-2">
                                  <span className="primary_text_color">
                                    <BadgeIcon width={20} height={20} />
                                  </span>
                                </div>
                                <div className="flex flex-col">
                                  <span className="primary_text_color text-[11px] leading-4 text-left text-[#0274F7] font-normal">
                                    {lang?.total_value || "Total Value"}
                                  </span>
                                  <span className="text-[13px] leading-4 text-left text-black font-bold">
                                    {prize?.symbol || "₹"}{prize?.reward_value}
                                  </span>
                                </div>
                              </div>

                              <div className="flex flex-col md:border-t-0 md:border-l pb-2 md:pb-0 border-b md:border-b-0">
                                <span className="primary_text_color text-[11px] leading-4 text-left text-[#0274F7] font-normal sm:pt-0 pl-0 sm:pl-5">
                                  {lang?.minimum_points_required ||
                                    "Minimum Points Required"}
                                </span>
                                <span className="text-[13px] leading-4 text-left text-black font-bold sm:pt-0  pl-0 sm:pl-5">
                                  {prize?.points}
                                </span>
                              </div>
                              {enddateError === 1 &&
                                winnerlist[index]?.email && (
                                  <div className="sm:border-t-0 sm:border-l l-0 sm:pl-5">
                                    <span className="primary_text_color text-[11px] leading-4 text-left text-[#0274F7] font-normal sm:pt-0 pl-0 sm:pl-5">
                                      {lang?.winner || "Winner"}
                                    </span>
                                    <h6 className="text-[11px]">
                                      {winnerlist[index]?.name}{" "}
                                    </h6>
                                    {contest_member_id ===
                                    winnerlist[index]?.contest_member_id ? (
                                      <p className="text-[11px]">
                                        {winnerlist[index]?.email}
                                      </p>
                                    ) : (
                                      <p className="text-[11px]">
                                        {winnerlist[index]?.email.replace(
                                          /(^\w).*(?=@)/,
                                          "$1********1"
                                        )}
                                      </p> // You can change this part as needed
                                    )}
                                  </div>
                                )}
                              {/* </div> */}
                            </div>
                            {prize.status === 1 && (
                              <div className=" flex rounded-md">
                                {prize.reward_type === 1 && (
                                  <button
                                    onClick={() => gotoRewardsPage(1, prize)}
                                    className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                  >
                                    <span>
                                      <InstructionIcon width={14} height={13} />
                                    </span>
                                    {lang?.click_here || "Click here"}
                                  </button>
                                )}

                                {prize.reward_type === 2 && (
                                  <button
                                    onClick={() => gotoExternalUl(prize)}
                                    className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                  >
                                    <span>
                                      <ExternalRewardIcon
                                        width={14}
                                        height={13}
                                      />
                                    </span>
                                    {lang?.click_here || "Click here"}
                                  </button>
                                )}

                                {prize.reward_type === 3 && (
                                  <button
                                    onClick={() => gotoRewardsPage(1, prize)}
                                    className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                  >
                                    <span>
                                      <VideoRewardIcon width={14} height={13} />
                                    </span>
                                    {lang?.watch_video || "Watch Video"}
                                  </button>
                                )}
                                {prize.reward_type === 4 && (
                                  <button
                                    onClick={() => gotoRewardsPage(1, prize)}
                                    className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                  >
                                    <span className="">
                                      <AudioRewardIcon width={14} height={13} />
                                    </span>
                                    {lang?.listen_music || "Listen Music"}
                                  </button>
                                )}

                                {prize.reward_type === 5 && (
                                  <button
                                    onClick={() => handleDownload(prize)}
                                    className="primary_btn_bg mt-2 w-32 sm:w-auto gap-2 px-3 py-2 flex items-center justify-center rounded text-[13px] leading-[15px] text-white border border-[#0274F7] bg-[#0274F7] hover:text-[#0274F7] hover:bg-white"
                                  >
                                    <span>
                                      <HostedRewardIcon
                                        width={14}
                                        height={13}
                                      />
                                    </span>
                                    {lang?.download || "Download"}
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      ))
                    ) : displayreward === 0 ? (
                      <p>
                        {lang?.no_prizes_available || "No Prizes available"}
                      </p>
                    ) : (
                      <div></div>
                    )}

                    {displayreward === 1 && (
                      <ShowRewards
                        setdisplayreward={setdisplayreward}
                        activerewards={activerewards}
                      />
                    )}
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

export default PrizeSetup;
